import { useRef, useState } from "react";
import { Button, Form, Grid, Input, Modal } from 'semantic-ui-react';
import '../styles/Login.scss';
import { useNavigate } from 'react-router-dom'
import { accountService } from '../services';
import { RequestPayload } from '../services/ApiClient/types';
import { AuthenticateRequest } from "../services/AccountService/types";
import AzureMapsComponent from '../components/MapContainer';
import { useUser } from '../components/AppProvider';
import { User } from '../services/types';
import { SSOLoginModal } from '../components/SSOLoginModal';

const Login = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoginError, setIsLoginError] = useState(false);
  const [loginError, setLoginError] = useState('Error');
  const [isLoading, setIsLoading] = useState(false);
  const [isSSOModalOpen, setIsSSOModalOpen] = useState(false);
  const loginsValid = password !== '' && username !== '';

  const handleTraditionalLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    let currentRoute: string = localStorage.getItem("route") ?? "Routed";

    let request: AuthenticateRequest = {
      username: username,
      password: password,
    };


    let payload: RequestPayload<AuthenticateRequest> = { payload: request };

    try {
      const response = await accountService.login(payload);
      localStorage.removeItem("courierId");
      
      if (response.success) {
        const token = response.result.jwtToken;
        localStorage.setItem("token", token);
        localStorage.setItem("authenticated", 'true');
        localStorage.setItem("route", currentRoute);

        let user: User = {
          userName: response.result.userPreferences.userName,
          userPreferences: response.result.userPreferences.userPreferences,
          userRestrictions: response.result.userPreferences.userRestrictions,
          applicationFeatures: response.result.userPreferences.applicationFeatures,
          courierId: response.result.courierId
        };

        const courierId = user.courierId ? user.courierId.toString() : null;
        if (courierId === null) {
          localStorage.setItem("route", 'Routed');
        }
        localStorage.setItem("courierId", courierId);
        setUser(user);
        navigate(`/${currentRoute}`);
      }
    } catch (err: any) {
      setIsLoginError(true);
      if (!loginsValid) {
        if (password === '') setLoginError('Password cannot be blank');
        if (username === '') setLoginError('Username cannot be blank');
      } else {
        setLoginError(err.data?.message || err.message || 'Login failed');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const loginRef = useRef({
    userName: '',
    password: ''
  })

  return (
    <div className='login-form'>
      <div className="grid_container">
        <Grid columns="1" style={{ height: '0px' }}>
          <Grid.Row>
            <Grid.Column xs={1}>
            </Grid.Column>
            <Grid.Column xs={8} style={{ display: 'flex', justifyContent: 'center' }} className="grid-column">
              <div className='fb-login-container'>
                <div className="fb-item fb-form">
                  <img className="logo" src='/images/logo.png' alt="Logo" />
                  <Form className='form-login' onSubmit={handleTraditionalLogin}>
                    <Form.Field className="username">
                      <input placeholder='Username'
                        id='username'
                        // value={username}
                        // onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value)} />
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => loginRef.current.userName = event.target.value} />
                    </Form.Field>
                    <Form.Field className="password">
                      <Input
                        type='password'
                        placeholder='Password'
                        id='password'
                        // value={password}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => loginRef.current.password = event.target.value} />
                    </Form.Field>
                    <div id="login-buttons">
                      <Button onClick={() => (setUsername(loginRef.current.userName), setPassword(loginRef.current.password))} disabled={isLoading} loading={isLoading} className="login" type='submit' color="blue">{!isLoading ? 'Log In' : 'Loading...'}</Button>
                      <Button 
                        className="sso-login" 
                        onClick={() => setIsSSOModalOpen(true)}
                        color="green"
                        type="button"
                      >
                        Sign in with SSO
                      </Button>
                      <Button className="forgotPass" onClick={() => navigate('forgotpassword')}>Forgot Password</Button>
                    </div>
                  </Form>
                </div>
                <div className="fb-item fb-map" style={{ width: '100vw', height: '80vh' }}>
                  <AzureMapsComponent />
                </div>
              </div>
            </Grid.Column>
            <Grid.Column xs={1}>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
      <div className="login_photo_container">
        <img className="login_photo" src='/images/login_picture.jpg' alt="Login" />
      </div>
      <Modal
        size={'mini'}
        open={isLoginError}
        dimmer={'blurring'}
        onClose={() => setIsLoginError(false)}
        closeIcon
      >
        <Modal.Header>Error Logging In</Modal.Header>
        <Modal.Content>{loginError}</Modal.Content>
      </Modal>
      <SSOLoginModal 
        isOpen={isSSOModalOpen}
        onClose={() => setIsSSOModalOpen(false)}
      />
    </div>
  )
}

export default Login